import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { notify } from 'react-notify-toast'

import { inspectionsConstants, uiConstants } from '../constants'

export function inspectionsUpload () {
  return {
    type: inspectionsConstants.INSPECTIONS_UPLOADING
  }
}

export function inspectionsUploadSuccess () {
  return {
    type: inspectionsConstants.INSPECTIONS_UPLOADING_SUCCESS
  }
}

export function loadInspections (payload) {
  return dispatch => {
    dispatch(loadingInspections(payload))
    axios({
      method: 'GET',
      url: URIS.inspections + '?id=' + payload,
      headers: loadHeaders()
    }).then(res => {
      dispatch(loadInspectionsSuccess(res.data))
    }).catch(error => {
      if (error.response !== undefined) { dispatch(loadInspectionsFailure(error.response.statusText)) } else { dispatch(loadInspectionsFailure(error.message)) }
      notify.show('Errore caricamento anomalie', uiConstants.toast.error, 3000)
    })
  }
}

function loadingInspections (payload) {
  return {
    type: inspectionsConstants.LOADING_INSPECTIONS,
    payload
  }
}

function loadInspectionsSuccess (payload) {
  return {
    type: inspectionsConstants.LOADING_INSPECTIONS_SUCCESS,
    payload
  }
}

function loadInspectionsFailure (payload) {
  return {
    type: inspectionsConstants.LOADING_INSPECTIONS_FAILURE,
    payload
  }
}
